<template>
  <div
    ref="modal"
    :class="$b()"
    tabindex="0"
    @keyup.esc="$emit('close')"
  >
    <div :class="$b('container')">
      <slot />
    </div>

    <div :class="$b('button-container')">
      <div :class="$b('close')">
        <IconButton
          :class="$b('button')"
          plain
          @click="$emit('close')"
        >
          <div :class="$b('button-inner')">
            <VisionIcon
              :class="$b('button-icon')"
              icon="fullscreen-exit"
              colour="black"
              size="small"
            />
          </div>
        </IconButton>
      </div>
      <Product360Toggle
        ref="toggle"
        :class="
          $b('button360', {
            hide:
              !(activeLifestyleIndex < staticProductImages.length) || !show360,
          })
        "
        :show-toggle="activeLifestyleIndex < staticProductImages.length"
        @update:active-slide-index="$emit('update:activeSlideIndex', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullScreenModal',
  props: {
    staticProductImages: {
      type: Array,
      default: () => [],
    },
    activeLifestyleIndex: {
      type: Number,
      default: 0,
    },
    activeSlideIndex: {
      type: Number,
      default: 0,
    },
    show360: {
      type: Boolean,
      required: true,
    },
  },
  emits: [
    'close',
    'update:activeSlideIndex',
  ],
  mounted() {
    this.$refs.modal.focus()
  },
}
</script>

<style lang="postcss" scoped>
.FullScreenModal {
  @apply fixed inset-0 z-50 bg-grey-lighter;

  &__container {
    @apply flex items-center justify-center h-full
      relative;
  }

  &__button-container {
    @apply absolute top-4 right-4
      z-40
      flex flex-row;
  }

  &__close {
    @apply flex items-center justify-center
      bg-white
      rounded-md;

    @screen md {
      @apply top-sm right-sm;
    }

    &:hover {
      .FullScreenModal__button-icon {
        @apply scale-90;
      }
    }
  }

  &__button {
    @apply relative;
  }

  &__button360 {
    @apply ml-xxs;

    &--hide {
      @apply hidden;
    }
  }

  &__button-inner {
    @apply flex items-center justify-center
      w-9 h-9
      p-1;

    @screen md {
      @apply w-12 h-12;
    }
  }

  &__button-icon {
    @apply transition-transform will-change-transform;
  }
}
</style>
